import { createAsyncThunk } from '@reduxjs/toolkit';
import { LanguagesApi } from '../../../api/base/Languages';

export const fetchLanguages = createAsyncThunk(
  'languages/fetchLanguages',
  async (): Promise<Array<any>> => {
    const response = await LanguagesApi.getLanguages();
    return response.data.data;
  },
);

// export const fetchMovies = createAsyncThunk(
//   `${commonMoviesModule}/fetchMoviesStatus`,
//   async (
//     filters: ICommonMoviesFilters,
//     { rejectWithValue },
//   ): Promise<IGetMoviesData | any> => {
//     try {
//       const response = await moviesApi.getMovies(filters);
//       return response.data;
//     } catch (err) {
//       return rejectWithValue(err);
//     }
//   },
// );

export const asyncLanguagesActions = {
  fetchLanguages,
};
